"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Locales = void 0;

var _lodash = require("lodash");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Locales = /*#__PURE__*/function () {
  function Locales(locales) {
    _classCallCheck(this, Locales);

    this.locales = locales || [];
  }

  _createClass(Locales, [{
    key: "findByUrl",
    value: function findByUrl(url) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        stripTranslations: false
      },
          stripTranslations = _ref.stripTranslations;

      var locale = (0, _lodash.find)(this.locales, {
        url: url
      });
      return (stripTranslations && locale ? (0, _lodash.omit)(locale, 'translation') : locale) || null;
    }
  }, {
    key: "findByCode",
    value: function findByCode(code) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        stripTranslations: false
      },
          stripTranslations = _ref2.stripTranslations;

      var locale = (0, _lodash.find)(this.locales, {
        code: code
      });
      return (stripTranslations && locale ? (0, _lodash.omit)(locale, 'translation') : locale) || null;
    }
  }, {
    key: "findByCountry",
    value: function findByCountry(country) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        stripTranslations: false
      },
          stripTranslations = _ref3.stripTranslations;

      var locale = (0, _lodash.find)(this.locales, {
        country: country
      });
      return (stripTranslations && locale ? (0, _lodash.omit)(locale, 'translation') : locale) || null;
    }
  }, {
    key: "findByLanguage",
    value: function findByLanguage(language) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        stripTranslations: false
      },
          stripTranslations = _ref4.stripTranslations;

      var locale = (0, _lodash.find)(this.locales, {
        language: language
      });
      return (stripTranslations && locale ? (0, _lodash.omit)(locale, 'translation') : locale) || null;
    }
  }, {
    key: "findByContentLanguage",
    value: function findByContentLanguage(contentLanguage) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        stripTranslations: false
      },
          stripTranslations = _ref5.stripTranslations;

      var locale = (0, _lodash.find)(this.locales, {
        contentLanguage: contentLanguage
      });
      return (stripTranslations && locale ? (0, _lodash.omit)(locale, 'translation') : locale) || null;
    }
  }, {
    key: "getLocales",
    value: function getLocales() {
      var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        stripTranslations: false
      },
          stripTranslations = _ref6.stripTranslations;

      if (stripTranslations) return (0, _lodash.map)(this.locales, function (locale) {
        return (0, _lodash.omit)(locale, 'translation');
      });
      return this.locales;
    }
  }, {
    key: "mapKeysCode",
    value: function mapKeysCode() {
      return (0, _lodash.mapKeys)(this.locales, function (locale) {
        return locale.code;
      });
    }
  }, {
    key: "mapKeysContentLanguage",
    value: function mapKeysContentLanguage() {
      return (0, _lodash.mapKeys)(this.locales, function (locale) {
        return locale.contentLanguage;
      });
    }
  }, {
    key: "getUrls",
    value: function getUrls() {
      return (0, _lodash.map)(this.locales, function (locale) {
        return locale.url || null;
      });
    }
  }, {
    key: "getCodes",
    value: function getCodes() {
      return (0, _lodash.map)(this.locales, function (locale) {
        return locale.code || null;
      });
    }
  }, {
    key: "getCountries",
    value: function getCountries() {
      return (0, _lodash.map)(this.locales, function (locale) {
        return locale.country || null;
      });
    }
  }, {
    key: "getLanguages",
    value: function getLanguages() {
      return (0, _lodash.map)(this.locales, function (locale) {
        return locale.language || null;
      });
    }
  }, {
    key: "getNativeLanguageNames",
    value: function getNativeLanguageNames() {
      return (0, _lodash.map)(this.locales, function (locale) {
        return locale.nativeLanguageName || null;
      });
    }
  }, {
    key: "getNativeCountryNames",
    value: function getNativeCountryNames() {
      return (0, _lodash.map)(this.locales, function (locale) {
        return locale.nativeCountryName || null;
      });
    }
  }, {
    key: "getContentLanguages",
    value: function getContentLanguages() {
      return (0, _lodash.map)(this.locales, function (locale) {
        return locale.contentLanguage || null;
      });
    }
  }]);

  return Locales;
}();

exports.Locales = Locales;